import { SingleRow } from './components/Single';
import { TupleRow } from './components/Tuple';

const RowSection = {
	Single: SingleRow,
	Tuple: TupleRow,
};

export default RowSection;
